import axios from "@/http/api";
import url from "@/interface/url";
import methods from "./method";
import i18n from "@/utils/i18n";

const request = (url, method, data) => {
  const lang = i18n.locale || "en_US";
  if (!data) {
    data = {};
  }
  if (lang) {
    if (typeof data === "string") {
      data += "&lang=" + lang;
    } else {
      data["lang"] = lang;
    }
  }
  if (url === "setting/getDefault") {
    let hostname = window.location.hostname;
    if (hostname !== "localhost" && hostname !== "10.0.0.160") {
      let hostnameset = hostname.split(".");
      let loginUrl = hostnameset[0] ? hostnameset[0] : "";
      // let loginUrl = "control";
      if (loginUrl) {
        data["loginUrl"] = loginUrl;
      } else {
        data["uId"] = 1;
      }
    } else {
      data["uId"] = 1;
    }
  }
  if (method && method === methods.get) {
    return axios({
      url: url,
      method: method,
      params: data
    });
  }
  return axios({
    url: url,
    method: method,
    data: data || {}
  });
};
const download = (url, data) => {
  return axios({
    url: url,
    method: methods.post,
    data: data,
    responseType: "blob"
  }).then(res => {
    const disposition = res.headers["content-disposition"];
    let fileName = "download.xlsx";
    if (disposition && disposition.includes("=")) {
      fileName = window.decodeURI(disposition.split("=")[1]);
    }
    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(
      new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
      })
    );
    link.target = "_blank";
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(link.href); // 释放URL 对象
    document.body.removeChild(link);
  });
};
const upload = (url, data) => {
  return axios({
    url: url,
    method: methods.post,
    data: data,
    headers: { "Content-Type": "multipart/form-data" }
  });
};
//字典
const dict = data => {
  return axios({
    url: url.DictData.listDictData,
    method: methods.get,
    params: { type: data }
  });
};
export default { request, dict, download, upload };
